// Short two-tone alert for the till, generated in the browser (no audio file to ship or cache).
let ctx = null;
let pending = false;

const tone = (c, freq, start, dur) => {
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, c.currentTime + start);
  gain.gain.exponentialRampToValueAtTime(0.25, c.currentTime + start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + start + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(c.currentTime + start);
  osc.stop(c.currentTime + start + dur + 0.05);
};

const play = (c) => {
  tone(c, 880, 0, 0.18);
  tone(c, 660, 0.22, 0.28);
};

export const playRecallChime = () => {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return false;
    ctx = ctx || new AC();
    if (ctx.state === 'running') { play(ctx); return true; }
    // Browsers block sound until the user interacts. Play on the next tap or keypress instead.
    if (!pending) {
      pending = true;
      const unlock = () => {
        if (!pending) return;
        pending = false;
        ctx.resume().then(() => play(ctx)).catch(() => {});
      };
      window.addEventListener('pointerdown', unlock, { once: true });
      window.addEventListener('keydown', unlock, { once: true });
    }
    ctx.resume().then(() => { if (ctx.state === 'running' && pending) { pending = false; play(ctx); } }).catch(() => {});
    return true;
  } catch {
    return false;
  }
};
